module.exports = __webpack_public_path__ + "static/media/bipedge-second-purple-overlay.8e56ed0b.png";